<template>
  <div
    @click="close"
    id="toast"
    class="cursor-pointer body-1 progress px-7 py-6 bg-teamfu-g-100 border border-teamfu-g-300 rounded-lg fixed z-50 min-w-[616px] ipadp:min-w-[80%] ipadp:text-xs ipadp:p-2 left-1/2 mr-[-50%] -translate-x-1/2"
    :style="{ color: 'var(--bg-grey-400)' }"
  >
    <p v-html="html"></p>
  </div>
</template>

<script>
import PropTypes from '@/helpers/propTypes';
import DOMPurify from 'dompurify';

export default {
  name: 'teamfu-toast',

  props: {
    text: PropTypes.STR(),
  },

  computed: {
    html() {
      return DOMPurify.sanitize(this.text);
    },
  },

  methods: {
    close() {
      this.$store.dispatch('popups/setToast', [null, 0]);
    },
  },
};
</script>

<style scoped>
.progress {
  animation: progress 0.2s ease;
  animation-iteration-count: 1;
  animation-fill-mode: forwards;
  animation-timing-function: linear;
}

@keyframes progress {
  0% {
    margin-top: 98vh;
  }
  10% {
    margin-top: 96vh;
  }
  20% {
    margin-top: 95vh;
  }
  30% {
    margin-top: 94vh;
  }
  40% {
    margin-top: 92vh;
  }
  50% {
    margin-top: 90vh;
  }
  60% {
    margin-top: 89vh;
  }
  70% {
    margin-top: 86vh;
  }
  80% {
    margin-top: 90vh;
  }
  90% {
    margin-top: 88vh;
  }
  100% {
    margin-top: 90vh;
  }
}
</style>
